import { CircleX, Clock3, Trophy, UserPlus, type LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

const STAGE_ICONS: Record<string, LucideIcon> = {
  new_lead: UserPlus,
  in_progress: Clock3,
  won: Trophy,
  lost: CircleX,
}

const STAGE_TONES: Record<string, string> = {
  won: "bg-accent-faded text-accent-display",
  lost: "bg-danger-faded text-danger-display",
}

export function StageIcon({ stageKey, className }: { stageKey: string; className?: string }) {
  const Icon = STAGE_ICONS[stageKey] || Clock3
  return <span className={cn("inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-page text-ink-muted", STAGE_TONES[stageKey], className)} aria-hidden="true"><Icon className="h-4 w-4" /></span>
}
